"use client";
import React from "react";
import type { HeroProps } from "@/types/sections/hero";
import { TextColorClassOrStyle } from "@/lib/colors";
import { cn } from "@/lib/utils";

export default function HeroCentered({ data }: { data: HeroProps }) {
  const {
    title,
    subtitle,
    buttons = [],
    badge,
    background,
    padding = "xl",
  } = data || {};

  const bgStyle =
    background?.type === "gradient"
      ? { backgroundImage: background.value }
      : background?.type === "color"
        ? { backgroundColor: background.value }
        : background?.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {};

  const paddingMap = {
    sm: "py-10 px-4",
    md: "py-16 px-6",
    lg: "py-20 px-6",
    xl: "py-28 px-8",
  };
  // Color for title & subtitle
  const tcl = TextColorClassOrStyle(data.colors?.title, "text-foreground");
  const scl = TextColorClassOrStyle(
    data.colors?.subtitle,
    "text-muted-foreground",
  );
  return (
    <section
      className={`${paddingMap[padding] || "py-20 px-6"} text-center`}
      style={bgStyle}
    >
      <div className="max-w-3xl mx-auto">
        {badge && (
          <span className="inline-flex items-center mb-4 text-sm font-medium text-primary bg-blue-100 px-3 py-1 rounded-full">
            {badge.icon && (
              <img src={badge.icon} alt="icon" className="w-4 h-4 mr-2" />
            )}
            {badge.text}
          </span>
        )}
        {title && (
          <h1
            className={cn("text-4xl sm:text-5xl font-bold mb-4", tcl.className)}
            style={tcl.style}
          >
            {title}
          </h1>
        )}
        {subtitle && (
          <p className={cn("text-lg mb-6", scl.className)} style={scl.style}>
            {subtitle}
          </p>
        )}
        {buttons.length > 0 && (
          <div className="flex justify-center gap-4 flex-wrap">
            {buttons.map((btn, idx) => (
              <a
                key={idx}
                href={btn.href}
                className={`px-5 py-3 rounded-lg text-sm font-medium transition ${
                  btn.style === "secondary"
                    ? "bg-secondary text-secondary-foreground border border-border hover:bg-secondary/80"
                    : "bg-primary text-primary-foreground hover:bg-primary/80"
                }`}
              >
                {btn.text}
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
